import defaultAttributes from '../defaultAttributes';

const ChevronDown = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '6 9 12 15 18 9' }]],
];

export default ChevronDown;
